import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

const InputText = ({
  model,
  value,
  isRequired,
  isReadonly,
  maxLength,
  phValue,
  mask,
  changeEvt,
  blurEvt,
  id,
}) => {
  // mask 사용법
  // 9: 0-9
  // a: A-Z, a-z
  // *: A-Z, a-z, 0-9

  const onMaskBlur = e => {
    let result;
    if (mask !== undefined) {
      const reg = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gim;
      result = e.target.value.replace(reg, '');
    } else {
      result = e.target.value;
    }

    if (blurEvt !== undefined) {
      blurEvt(model, result);
    }
  };

  const onMaskChange = e => {
    let result;
    if (mask !== undefined) {
      const reg = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gim;
      result = e.target.value.replace(reg, '');
    } else {
      result = e.target.value;
    }

    if (changeEvt !== undefined) {
      changeEvt(model, result);
    }
  };

  return (
    <>
      {mask && mask.length > 0 ? (
        <InputMask
          id={id}
          className="form-control sm"
          type="text"
          value={value[model]}
          required={isRequired}
          readOnly={isReadonly}
          disabled={isReadonly}
          placeholder={phValue}
          mask={mask}
          onChange={onMaskChange}
          onBlur={onMaskBlur}
          alwaysShowMask={true}
          aria-label={id}
        />
      ) : (
        <input
          id={id}
          className="form-control sm"
          type="text"
          value={value[model]}
          required={isRequired}
          readOnly={isReadonly}
          disabled={isReadonly}
          maxLength={maxLength}
          placeholder={phValue}
          mask={mask}
          onChange={onMaskChange}
          onBlur={onMaskBlur}
          alwaysShowMask={true}
          aria-label={id}
        />
      )}
    </>
  );
};

InputText.PropTypes = {
  model: PropTypes.string.isRequired,
  value: PropTypes.object.isRequired,
  isRequired: PropTypes.bool.isRequired,
  isReadonly: PropTypes.bool.isRequired,
  maxLength: PropTypes.number,
  phValue: PropTypes.string,
  mask: PropTypes.string,
  changeEvt: PropTypes.func.isRequired,
  blurEvt: PropTypes.func,
  id: PropTypes.string,
};

export default InputText;
